(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vn-trust-icons"] && !Shopify.designMode) return;
  try {
    /* "Guia de tallas": la app lo coloca encima del boton de compra; aqui se mueve a la
     etiqueta de la talla, como en la referencia (y se vuelve a mover si la app lo recoloca) */
  (() => {
    const move = () => {
      const btn = document.querySelector('.product-details .jsc-size-chart-button');
      if (!btn) return;
      const sw = [...document.querySelectorAll('.product-details .swatch-single')].find((s) => {
        const n = s.querySelector('.swatch-option-name');
        return n && /^\s*talla/i.test(n.textContent);
      });
      const lab = sw && sw.querySelector('label.swatch-label');
      if (lab && !lab.contains(btn)) lab.appendChild(btn);
    };
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; move(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
    move();
  })();
  } catch(e) { console.error(e); }
})();

})();
